import React from 'react'
import { Login } from './main-page/Login'

export default function LoginM() {
  return (
    <div>

        <Login/>
    </div>
  )
}
